import media from 'common-ui-components/src/vtj/theme/media'
import variables from 'common-ui-components/src/vtj/theme/variables'
import colors from 'common-ui-components/src/vtj/theme/colors'

/*
Example helper usage:
import { responsiveMaxWidth } from './helpers;

const PlaceholderInput = styled.input`
  ${responsiveMaxWidth()}
`;

*/

export function responsivePadding() {
  return `
      padding-left: ${variables.padding}px;
      padding-right: ${variables.padding}px;
      ${media.tabletAndDesktop}{
        padding-left: ${variables.desktopPadding}px;
        padding-right: ${variables.desktopPadding}px;
      }
    `
}

export function paddingForMobileMaxContent() {
  return `
    ${media.mobileContent}{
      padding-left: ${variables.padding}px;
      padding-right: ${variables.padding}px;
    }
  `
}

export function responsiveMaxWidth(withMobilePadding) {
  const mobilePadding = withMobilePadding ? paddingForMobileMaxContent() : ''
  return `
      max-width: ${variables.contentMaxWidth}px;
      ${media.tabletMaxContent}{
        max-width: ${variables.tabletContentMaxWidth}px;
      }
      ${media.desktopMaxContent}{
        max-width: ${variables.desktopContentMaxWidth}px;
      }
      ${mobilePadding}
  `
}

export function responsiveWidth(withMobilePadding) {
  const mobilePadding = withMobilePadding ? paddingForMobileMaxContent() : ''
  return `
      width: ${variables.contentMaxWidth}px;
      ${media.tabletMaxContent}{
        width: ${variables.tabletContentMaxWidth}px;
      }
      ${media.desktopMaxContent}{
        width: ${variables.desktopContentMaxWidth}px;
      }
      ${mobilePadding}
  `
}

export function placeholder(color) {
  return `
    &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
        color: ${color};
    }
    &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: ${color};
    }
    &::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: ${color};
    }
    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${color};
    }
    `
}

export function suomifiOutline() {
  return `
  :focus {
    box-shadow: 0 0 3px 0 ${colors.actionBlue};
    outline: 0;
  }
  `
}

export function suomifiFocus() {
  return `
  &:focus {
    outline: none;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      pointer-events: none;
      top: -2px;
      right: -2px;
      bottom: -2px;
      left: -2px;
      border-radius: 2px;
      background-color: transparent;
      border: 0px solid #fff;
      box-sizing: border-box;
      box-shadow: 0 0 0 2px hsl(196, 77%, 44%);
      z-index: 9999;
    }
  }
  `
}

export function hideFromPrint() {
  return `
  @media print {
    display:none !important;
  }
  `
}

export function hideFromScreen() {
  return `
  @media screen {
    display:none !important;
  }
  `
}

export function getColorByType({ type }) {
  const colorMap = {
    success: 'successBackground',
    info: 'infoBlue',
    warning: 'warningBackground',
    error: 'errorItemColor',
    changeRequest: 'infoBlue',
  }
  return colors[colorMap[type]]
}
